export default __webpack_public_path__ + "static/media/Pessoas Branco.4ae41fae.png";